module.exports = __webpack_public_path__ + "static/media/producer_studio.fc2653ab.png";